import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { Router } from "@angular/router";
import { IRisksFilters } from "@gloria-public/home/domain/interfaces/home.interface";
import { IRiskTemplateResponse } from "@gloria-public/risk/domain/interfaces/risk.interface";
import { BackendTableDataSource } from "@shared/utils/backend-table.datasource";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-not-ordered-risk-table",
  templateUrl: "./not-ordered-risk-table.component.html",
  styleUrls: ["./not-ordered-risk-table.component.scss"],
})
export class notOrderedRiskTableComponent implements OnInit, OnDestroy {
  @Input() title = ""; // Title displayed above the table
  @Input() dataSource!: BackendTableDataSource<IRiskTemplateResponse>; // The datasource to use. Created by the parent and injected here, so the parent controls which API calls are made.
  @Input() filters: IRisksFilters = { lang: "en", page: 1, pageSize: 10 }; // Initial filters (page, pageSize). The type should already be set by the parent.
  @Input() hasPredispositions = false;

  public totalCount = 0;
  public readonly pageSizeOptions = [5, 10, 20, 50];
  public differentRisks: IRiskTemplateResponse[] = [];

  /** Emits when the component is destroyed, used to complete all active subscriptions */
  private onDestroy$ = new Subject<void>();

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.dataSource.count$.pipe(takeUntil(this.onDestroy$)).subscribe((count) => {
      this.totalCount = count;
    });
    this.dataSource
      .connect()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((risks) => {
        this.differentRisks = risks;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  /**
   * Handles pagination changes
   * @param event Pagination event
   */
  public onPage(event: PageEvent): void {
    this.filters = {
      ...this.filters,
      page: event.pageIndex + 1,
      pageSize: event.pageSize,
    };

    this.loadDataSource();
  }

  /**
   * Loads not ordered risks using current filters
   */
  private loadDataSource(): void {
    this.dataSource.loadData({
      page: this.filters.page ?? 1,
      pageSize: this.filters.pageSize ?? 10,
    });
  }

  /**
   * Navigates to risk details page
   * @param id risk identifier
   */
  goToRisk(id: string): void {
    this.router.navigate(["/risks", id]);
  }
}
